import { Box } from '@chakra-ui/react';

import { Condition, Iteration } from 'Component/others';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnLinks = ({ value }) => {
  return (
    <Box className={styles['column__container']}>
      <Condition
        statement={value?.length > 0}
        fallback={<TextRegular>-</TextRegular>}
        children={
          <Iteration
            items={value}
            render={(item, index) => {
              return (
                <TextRegular key={index} className={styles['column__text']}>
                  <a href={item} target="_blank" rel="noopener noreferrer" className={styles['column__link']}>
                    {item}
                  </a>
                </TextRegular>
              );
            }}
          />
        }
      />
    </Box>
  );
};

export default ColumnLinks;
